function Header() {
    return (
        <header>
            <h1>Geeks of the World, Unite!</h1>
        </header>
    );
}

export default Header;
